import { CloseButton } from "@vega-core/components/Buttons/CloseButton/CloseButton";

export const FullScreenModalHeader = ({
  setIsOpen,
  title,
}: {
  setIsOpen: (isOpen: boolean) => void;
  title: string;
}) => (
  <div className="p-4 sm:pt-6 flex items-center justify-between w-full">
    <div className="flex items-center gap-4 sm:gap-6">
      <div className="flex items-center py-2 pr-4 sm:pr-6 mr-4 sm:mr-6 border-r-[1px] border-border/primary">
        <CloseButton noBg onClick={() => setIsOpen(false)} />
      </div>
      <div className="body-extra-large-semibold">{title}</div>
    </div>
  </div>
);
